export default {
  methods: {
    setBoolean(inputKey, defaultValue) {
      if (!this.model) return;
      this.model[inputKey] = this.item ? this.item[inputKey] === 1 : defaultValue;
    }
  }
};
